import React, {useState, useContext, useEffect} from "react";
import './DocumentosSubtabla.css';
import RRDocumentoForm from "./RRDocumentoForm";
import FormDocumento from "../FormDocumento/FormDocumento";
import { createEstructuraDocumento, estructuraDocumento } from "../../utils/estructuras";
import documentoContext from '../../context/documentosContext/documentosContex.js';


const DocumentosSubtabla = ({documentos, handleChangeActivo, selectSelect, tablaSeleccionada, modo, docFiles, onDocFileChange}) => {

    const [showAdd,setShowAdd] = useState(false);
    const [data,setData] = useState('');
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    const [indexToUpdate,setIndexToUpdate] = useState(-1);
    const [options,setOptions] = useState([]);

    const dContext = useContext(documentoContext);
    const {documentosList,actualizarDocumentoList} = dContext;

    const handleChange = (e = {}, i, prop='', value=undefined) => {
        let newDocs = documentos.slice();
        if(prop != '' && value != ''){
            if(prop == 'documento' && newDocs[i].documento.label == '' ) newDocs.push({...createEstructuraDocumento()});
            newDocs[i][prop] = value;
        }else{
            let {name,value} = e.target;
            newDocs[i][name] = value;
        }
        handleChangeActivo({},'documentos',newDocs);
    }

    const handleDelete = (doc, index) => {
        let actualDocs = documentos.slice();
        if(doc.fecha != ''){
            let docsToUpdate = actualDocs.filter((p,i) => i != index);
            handleChangeActivo({},'documentos',docsToUpdate);                         
        }
    }

    const minimizar = () =>{
        setShowAdd(false);
    }

    const createOptions = () => {
        if(documentosList != undefined){
            let optionsDocumentos = documentosList.map(d => {return {id: d._id, value: d.codDocumento, label: d.name, fecMod: d.fecMod, fecAlt: d.fecAlt}})    
            setOptions(optionsDocumentos);
        }
    }

    useEffect(()=>{
        actualizarDocumentoList();
    },[])

    useEffect(()=>{
        createOptions();
    },[documentosList])

    return <div className={`${(tablaSeleccionada != 'docVencimiento') && 'inactive'} documentosSubtablaDiv`}>
        <label>Documentos</label>
        <div className={`headerSubtabla ${(modo != 'Vista') ? 'sixColumns' : ''}`}>
            {modo != 'Vista' && <label id="deleteLabel"></label>}
            <label>Documento</label>
            <label>Observaciones</label>
            <label>Fecha Vencimiento</label>
            <label>Alerta Anticipo</label>
            <label>Archivo</label>
        </div>
        <div className="bodyTable">
            {(documentos != undefined) && documentos.map((d, i) => <RRDocumentoForm key={i} index={i} documento={d} setData={setData} modo={modo} handleChange={handleChange} handleDelete={handleDelete} setShowAdd={setShowAdd} setIndexToUpdate={setIndexToUpdate} setNuevoEditado={setNuevoEditado} optionsDocumentos={options} archivoDoc={docFiles?.find(f => f.codDocumento === d.documento.value && f.accion !== 'DELETE')} onFileChange={onDocFileChange}/>)}
        </div>
        {showAdd && <FormDocumento data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeDocumentos={handleChange} index={indexToUpdate}/>}
    </div>

}

export default React.memo(DocumentosSubtabla);